import React from 'react';
import { PropTypes } from 'prop-types';

import ReasonToKnowGrid from 'components/ReasonToKnowGrid';

const CICWorkflowQueue = ({
  settings,
  permissions,
  isLoading,
  queue,
  takeItem,
  changePageCallback,
  pageNumber,
  pageSize,
  sortBy,
  sortDirection,
  filters,
  showUserColumn
}) => (
  <div>
    <ReasonToKnowGrid
      permissions={ permissions }
      isLoading={ isLoading }
      rowData={ queue != null ? queue.items : null }
      totalCount={ queue != null ? queue.totalCount : 0 }
      pageNumber={ pageNumber }
      pageSize={ pageSize }
      sortBy={ sortBy }
      sortDirection={ sortDirection }
      filters={ filters }
      takeItem={ takeItem }
      changePageCallback={ changePageCallback }
      showUserColumn={ showUserColumn }
    />
  </div>
);

CICWorkflowQueue.propTypes = {
  settings: PropTypes.shape(),
  permissions: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  queue: PropTypes.shape(),
  takeItem: PropTypes.func.isRequired,
  changePageCallback: PropTypes.func,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  filters: PropTypes.shape(),
  showUserColumn: PropTypes.bool
};

CICWorkflowQueue.defaultProps = {
  settings: null,
  permissions: null,
  isLoading: false,
  queue: null,
  sortBy: null,
  sortDirection: null,
  filters: null,
  changePageCallback: null,
  showUserColumn: false
};

export default CICWorkflowQueue;
